<div class="modal-content">
    <h1 mat-dialog-title>Your session has timed out.</h1>
    <div mat-dialog-content class="dialog-content">
        <span class="dialog-content-error">
            {{BodyMessage}}
        </span>
        <p>
            Please sign-in again to access the form.
        </p>
    </div>
    <div mat-dialog-actions align="end">
        <button id="session-lo-dialog-ok" mat-flat-button color="accent" class="btn-sm" (click)="OnClickRedirectToLogin()">Okay</button>
    </div>
</div>
